import React from 'react';
import { ServerStore } from '@seedlang/stores';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { Theme } from '@seedlang/constants';

const Wrapper = styled.div`

`;

const Alert = styled.div`
  background: ${props => props.background};
  display: inline-block;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  color: white;
  margin: 0 0 10px 0;
  border-radius: 3px;
`;

export const AuthenticateStatus = ({ errorMessage, successMessage }) => (
  <Wrapper>
    {
      !successMessage && errorMessage &&
        <Alert
          background={Theme.orange}
        >
          {errorMessage}
        </Alert>
    }
    {
      successMessage &&
        <Alert
          background={Theme.green}
        >
          {successMessage}
        </Alert>
    }
  </Wrapper>
);

const AuthenticateStatusWrapper = observer(() => (
  <AuthenticateStatus
    errorMessage={ServerStore.errorMessage}
    successMessage={ServerStore.successMessage}
  />
));

export default AuthenticateStatusWrapper;
